export default function Products() {
  const products = [
    {
      name: 'VPN Shield',
      description: 'Secure your connection with military-grade encryption',
      image: 'https://public.readdy.ai/ai/img_res/b9ac88f7953b8ea17596bdbcf81e7821.jpg',
      bgColor: 'from-[#E3F2FD] to-[#BBDEFB]'
    },
    {
      name: 'Smart Cleaner',
      description: 'Optimize storage and boost device performance',
      image: 'https://readdy.ai/api/search-image?query=elegant%20mobile%20cleaner%20application%20icon%20with%20light%20gray%20gradient%20background%20minimalist%20broom%20or%20sparkle%20symbol%20centered%20clean%20modern%20iOS%20utility%20app%20design%20professional%20optimization%20emblem&width=400&height=300&seq=product-cleaner&orientation=landscape',
      bgColor: 'from-[#F5F5F5] to-[#E0E0E0]'
    },
    {
      name: 'Privacy Guard',
      description: 'Complete privacy protection for your mobile life',
      image: 'https://readdy.ai/api/search-image?query=sophisticated%20privacy%20guard%20application%20icon%20with%20soft%20purple%20gradient%20background%20minimalist%20lock%20or%20eye%20symbol%20centered%20clean%20professional%20iOS%20security%20app%20design%20elegant%20protection%20emblem&width=400&height=300&seq=product-privacy&orientation=landscape',
      bgColor: 'from-[#F3E5F5] to-[#E1BEE7]'
    }
  ];

  return (
    <section id="products" className="py-32 bg-white">
      <div className="container mx-auto px-16">
        <div className="text-center mb-20">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="text-sm uppercase tracking-widest text-[#2A2A2A]" style={{ fontFamily: 'Inter, sans-serif' }}>
              Our Products
            </span>
          </div>
          <h3 className="text-6xl font-bold text-[#2A2A2A]" style={{ fontFamily: 'Inter, sans-serif' }}>
            iOS Applications
          </h3>
        </div>

        <div className="grid grid-cols-3 gap-8 max-w-7xl mx-auto" data-product-shop>
          {products.map((product, index) => (
            <div key={index} className="bg-[#F5F5F5] rounded-3xl overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className={`h-64 bg-gradient-to-br ${product.bgColor} flex items-center justify-center p-8`}>
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="p-10 text-center">
                <h4 className="text-2xl font-medium text-[#2A2A2A] mb-3" style={{ fontFamily: 'Inter, sans-serif' }}>
                  {product.name}
                </h4>
                <p className="text-sm text-[#6B6B6B] mb-6 leading-relaxed">
                  {product.description}
                </p>
                <button className="w-4/5 mx-auto py-3 border-2 border-[#2A2A2A] text-[#2A2A2A] rounded-full font-medium hover:bg-[#2A2A2A] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer">
                  Learn More
                </button>
                <p className="text-xs text-[#999] mt-4">
                  Available on iOS App Store
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}